import { render, staticRenderFns } from "./UIMoneyFormat.vue?vue&type=template&id=7ac4443a&scoped=true"
import script from "./UIMoneyFormat.vue?vue&type=script&lang=ts"
export * from "./UIMoneyFormat.vue?vue&type=script&lang=ts"
import style0 from "./UIMoneyFormat.vue?vue&type=style&index=0&id=7ac4443a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac4443a",
  null
  
)

export default component.exports